import { toast } from '@/components/toast';
import { useAnalytics } from '@/services/analytics';
import { deleteAgentWithKnowledge } from '@/services/api';
import { logger } from '@/services/logger';
import { useMutation, useQueryClient } from 'react-query';
import { GET_AGENTS_KEY } from './useGetAgents';

export function useDeleteAgentFromLibrary() {
    const mixpanel = useAnalytics();
    const queryClient = useQueryClient();

    return useMutation((id: string) => deleteAgentWithKnowledge(id), {
        onError: async (err: any, agentId) => {
            await queryClient.invalidateQueries(GET_AGENTS_KEY);
            mixpanel?.track('delete-agent', { event: 'failure', agentId });
            if (err.response.status !== 404) {
                logger.error(`Could not delete agent ${agentId}`, { err });
                toast.error({ title: `Could not delete agent`, toastId: `agent-delete-error` });
            }
        },
        onSuccess: async (_, agentId) => {
            await queryClient.invalidateQueries(GET_AGENTS_KEY);
            mixpanel?.track('delete-agent', { event: 'success', agentId });
            toast.success({ title: 'Your agent was successfully deleted' });
        },
    });
}
